module.exports = __webpack_public_path__ + "img/06955557000162.4f8360ce.png";